'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _userIngredientForm = require('./user-ingredient-form.component');

var _userIngredientForm2 = _interopRequireDefault(_userIngredientForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.admin.userIngredients.userIngredientForm', []).component('userIngredientForm', _userIngredientForm2.default).name;


// WEBPACK FOOTER //
// ./components/app/admin/user-ingredients/user-ingredient-form/user-ingredient-form.module.js